export default __webpack_public_path__ + "static/media/chashushuli.fbeec1d1.png";